<template>
  <div width="560px" height="1000px" style="padding-top: 10px">
    <div v-if="listData.length > 0">
      <div v-if="mode == 1">
        <div class="grid">
          <div class="head_text">項目名</div>
          <div class="head_text">kg</div>
          <div class="head_text">CO2重量</div>
        </div>

        <div
          class="grid"
          style="margin-top: 5px"
          :key="index"
          v-for="(item, index) in listData"
        >
          <div
            class="center_aligned_container item_name_text ellipsis_text item_padding"
          >
            {{ item.label }}
          </div>
          <div class="center_aligned_container item_value_text item_padding">
            {{ item.itemWeight }}
          </div>
          <div style="display: inline-flex">
            <div
              class="bar"
              :style="{
                width: item.percentage + '%',
                'background-color': getBarColor(index),
              }"
            ></div>
            <div class="item_value_text center_aligned_container">
              {{ item.itemCo2Weight + "kg" }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="mode == 0">
        <transition-group name="items">
          <div
            style="margin-top: 5px"
            :key="item.label"
            v-for="(item, index) in listData"
          >
            <div style="display: inline-flex">
              <div
                class="item_name_text ellipsis_text item_padding"
                style="font-weight: 600"
              >
                {{ item.label }}
              </div>
              <div
                class="item_value_text item_padding"
                v-if="item.itemWeight.length > 0"
                style="align-self: center"
              >
                {{ item.itemWeight + "kg" }}
              </div>
            </div>
            <div style="display: inline-flex; width: 100%; height: 20px">
              <div
                class="bar"
                :style="{
                  width: item.percentage + '%',
                  'background-color':
                    barColorMap != null
                      ? barColorMap.get(item.label)
                      : getBarColor(index),
                }"
              ></div>
              <div class="item_value_text center_aligned_container">
                {{ item.itemCo2Weight + "kg" }}
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <div v-else>
      <DataNotFound />
    </div>
  </div>
</template>

<script>
import utils from '../../mixins/utils'
import DataNotFound from '../common/DataNotFound'

export default {
  name: 'ModalHorizontalBarChart',
  components: { DataNotFound },
  props: {
    receivedData: {
      type: Object,
      default: () => {}
    },
    itemWeightInGram: {
      type: Object,
      default: () => {}
    },
    barColorMap: {
      type: Map,
      default: null
    },
    barColors: {
      type: Array,
      default: () => ['#D76829', '#E1802C', '#EA992E', '#F5B232', '#FECC36']
    },
    mode: {
      type: Number,
      default: 0
    }
  },
  mixins : [utils],
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      // listDataを初期化しないと絞り込みのたびにデータが積み重なってしまうため、ここで初期化する
      this.listData = []
      // receivedData分回してlistDataを作成する
      const map = new Map(Object.entries(this.receivedData))
      const itemWeight = this.itemWeightInGram != null ? new Map(Object.entries(this.itemWeightInGram)) : new Map()
      if(map.size == 0) {
        return
      }

      let maxValue = Number(Object.values(this.receivedData)[0]) / 1000 // 一番大きい
      map.forEach((val, key) => {
        let datalabel = String(key)
        let data = Number(val) / 1000
        let percentage = data / maxValue * 100

        let weightInGram = itemWeight.get(key)
        let weight = weightInGram != null ?  this.convertToFormattedNumber(Number(weightInGram) / 1000) : ''

        this.listData.push({
            label: datalabel,
            itemWeight: weight,
            itemCo2Weight: this.convertToFormattedNumber(data, 1),
            percentage: percentage
          })
      });
    },
    getBarColor(position) {
      return position < 5 ? this.barColors[position] : this.barColors.at(-1)
    }
  },
  watch: {
    receivedData: function() {
      this.fetchData()
    }
  },
  data() {
    return {
      dialog: false,
      listData: [],
    }
  }
}

</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 3fr 3fr 20fr;
}

.head_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.17px;
  color: #343a3f;
}

.item_name_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-transform: capitalize;
  color: #343a3f;
}

.item_value_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 1px;
  color: #343a3f;
}

.item_padding {
  padding-right: 5px;
}

.bar {
  border-radius: 4px;
  margin-right: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
}

.center_aligned_container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.ellipsis_text {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  word-wrap: brek-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: start;
}

.items-leave-active,
.items-enter-active {
  transition: opacity 1s, transform 1s ease;
}
.items-leave-to,
.items-enter {
  opacity: 0;
  transform: translateX(50px);
}
.items-leave,
.items-enter-to {
  opacity: 1;
}
.items-move {
  transition: transform 1s;
}
</style>
